import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Spinner from "../Spinner/Spinner";

function WithdrawlStart_Stop() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // let user = "";
  const [referralApi, setreferralApi] = useState([]);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [search, setSearch] = useState("");
  const [uplineid, setuplineid] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [currentPage2, setcurrentPage2] = useState(1);
  const [listPerpage2, setlistPerpage2] = useState(10);
  const [positionfilter, setpositionfilter] = useState("0");
  const [StatusFilter, setStatusFilter] = useState("");
  const [allMember, setAllMember] = useState([]);
  const [fromRegdate, setfromRegdate] = useState("");
  const [toRegdate, settoRegdate] = useState("");
  const [isloading, setisloading] = useState(false);

  const referral_API = async () => {
     setisloading(true);
    try {
      let responceRight = await API?.post(
        "/WithdrawalStartList",
        {
          loginid: userId,
          uid: search,
          status: StatusFilter,
          PageIndex: currentPage2,
          PageSize: listPerpage2,
          uplineid: uplineid,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      //console.log("memberlist-->", responceRight.data.data[0]);
      setAllMember(responceRight.data.TotalRecords);
      responceRight = responceRight.data.data[0];
      setleftreferralApi([]);
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: item.row,
          user_id: `${item?.user_id} `,
          f_name: `${item?.f_name} `,
          wallet: item.wallet,
          Withdrawl_status: item.Withdrawl_status_ss,
          Withdrawl_status_color:
            item?.Withdrawl_status_ss == "Stop" ? (
              <span style={{ color: "red" }}>{item?.Withdrawl_status_ss}</span>
            ) : (
              <span style={{ color: "green" }}>
                {item?.Withdrawl_status_ss}
              </span>
            ),
          staking: (
            <>
              <button
                className={`${
                  item?.Withdrawl_status == 1 ? "btn-danger" : "btn-success"
                } btn`}
                onClick={() =>
                  ChangeWithStatus(
                    item?.uid,
                    item?.Withdrawl_status_ss == "Stop" ? 1 : 0,
                    2,
                  )
                }
              >
                {item?.withdrawl_status == 1 ? "Stop" : "Start"}
              </button>
            </>
          ),
        });

        setleftreferralApi(arrayLeft);
        setisloading(false);
      });
      setisloading(false);
    } catch (e) {
      setisloading(false);
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const ChangeWithStatus = async (uid, status, type) => {
    try {
      if (!window.confirm("Are you sure, you want to update..?")) {
        return;
      }
      let res = await API?.post(
        "/WithdrawlStartStopPost",

        {
          loginid: userId,
          uid: uid,
          status: status,
          type: type,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.log("res_block", res);
      res = res.data.data;
      if ((res = "success")) {
        toast.success("Updated Successfully !!");
        referral_API();
      } else {
        toast.error(res);
      }
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
  }, [currentPage2, listPerpage2]);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const indexOfLastPost2 = currentPage2 * listPerpage2;
  const indexOfFirstPage2 = indexOfLastPost2 - listPerpage2;
  const currentPost = referralApi.slice(indexOfFirstPage, indexOfLastPost);
  const currentPostleft = leftreferralApi;

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "User Id", accessor: "user_id" },
      { Header: "Name", accessor: "f_name" },
      { Header: "Wallet Address", accessor: "wallet" },
      { Header: "Withdrawl Status", accessor: "Withdrawl_status_color" },
      { Header: " Action", accessor: "staking" },
      // { Header: "Edit", accessor: "edit" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page content_page_hit">
        <div class="content">
          <div class="container">
            {/* <-- inline Form --> */}
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-primary">
                  <div class="panel-heading">
                    <h4 class="panel-title">Withdrawl Start Stop</h4>
                  </div>
                  <div class="panel-body">
                    <form
                      action="#"
                      method="post"
                      class="ng-pristine in-ip-1 ng-valid"
                    >
                      <div class="form-inline" role="form">
                        <div class="col-md-12">
                          <div class="col-lg-2 col-xl-2 col-md-2">
                            <label>User Id</label>
                            <br />
                            <input
                              class="form-control in-ip-1"
                              id="uid"
                              onChange={(e) => setSearch(e.target.value)}
                              name="uid"
                              placeholder="Enter User Id"
                              type="text"
                              value={search}
                            />
                          </div>
                          <div class="col-lg-2 col-xl-2 col-md-2">
                            <label>Sponsor Id</label>
                            <br />
                            <input
                              class="form-control in-ip-1"
                              onChange={(e) => setuplineid(e.target.value)}
                              placeholder="Enter Sponsor Id"
                              type="text"
                              value={uplineid}
                            />
                          </div>
                          <div class="col-lg-2 col-xl-2 col-md-2">
                            <label>Withdrawal Status</label>
                            <select
                              className="form-control"
                              onChange={(e) => setStatusFilter(e.target.value)}
                              value={StatusFilter}
                            >
                              <option value="">All Status</option>
                              <option value="1">Start</option>
                              <option value="0">Stop</option>
                            </select>
                          </div>

                          <div class="col-lg-1 col-xl-1 col-md-1">
                            <br />
                            <input
                              type="button"
                              onClick={() => (
                                referral_API(),
                                setcurrentPage2(1)
                              )}
                              class="btn btn-lg btn-primary"
                              disabled={isloading}
                              value={isloading ? "Loading.." : "Search"}
                            />
                          </div>
                          <div class="col-lg-1 col-xl-1 col-md-1">
                            <br />
                            <input
                              type="button"
                              onClick={() => ChangeWithStatus(0, 1, 1)}
                              class="btn btn-lg btn-primary"
                              value="Start All"
                            />
                          </div>
                          <div class="col-lg-1 col-xl-1 col-md-1">
                            <br />
                            <input
                              type="button"
                              onClick={() => ChangeWithStatus(0, 0, 1)}
                              class="btn btn-lg btn-primary"
                              value="Stop All"
                            />
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              {isloading ? (
                <Spinner />
              ) : (
                <div class="col-md-12">
                  <div class="panel panel-default">
                    <div class="panel-body" style={{ overflow: "scroll" }}>
                      <Table data={currentPostleft} columns={my_team.cols} />

                      <Table_Buttons
                        indexOfFirstPage={indexOfFirstPage2}
                        indexOfLastPost={indexOfLastPost2}
                        setcurrentPage={setcurrentPage2}
                        currentPage={currentPage2}
                        totalData={allMember}
                        listPerpage={listPerpage2}
                        handleRowsPerPageChange={setlistPerpage2}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default WithdrawlStart_Stop;
